export default class AbstractThirdParty {
  globalName;

  trackMethod;

  waitTimeout = 1000;

  waitNumber = 10;

  queue = [];

  timeoutId = null;

  spentWait;

  started = false;

  addToQueue(func) {
    this.queue.push(func);
  }

  execQueue(fromTimer = false) {
    // setup timeout on first call
    if (!this.started) {
      this.started = true;
      this.spentWait = this.waitNumber;
    }
    if (!this.queue.length) return;
    if (this.globalName in window) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      while (this.queue.length) {
        const qfunc = this.queue.shift();
        qfunc();
      }
    } else if (this.spentWait && (!this.timeoutId || fromTimer)) {
      this.spentWait--;
      this.timeoutId = setTimeout(() => this.execQueue(true), this.waitTimeout);
    } else if (!this.spentWait) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this.onUnavailable();
    }
  }

  track(...params) {
    this.callMethod(this.trackMethod, params);
  }

  callMethod(methodName, args) {
    this.addToQueue(() => window[this.globalName][methodName](...args));
    this.execQueue();
  }

  onUnavailable() {
    setTimeout(() => {
      throw new Error(`Third party library ${this.globalName} wasn't loaded within ${this.waitNumber * this.waitTimeout / 1000} sec`);
    }, 0);
  }
}
